import { RefObject } from 'react';

export const scrollToBottom = (ref: RefObject<HTMLDivElement | null>) => {
  // TODO: 이런 모달에서 스크롤 바텀으로 유지시키는 이슈 해결 필요
  setTimeout(() => {
    if (ref.current) {
      ref.current.scrollTo({
        top: ref.current.scrollHeight,
      });
    }
  }, 100);
};
